module.exports = __webpack_public_path__ + "img/003.5406aef3.jpg";